import { render, staticRenderFns } from "./InTour.vue?vue&type=template&id=4f8957d9&scoped=true&"
import script from "./InTour.vue?vue&type=script&lang=js&"
export * from "./InTour.vue?vue&type=script&lang=js&"
import style0 from "./InTour.vue?vue&type=style&index=0&id=4f8957d9&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8957d9",
  null
  
)

export default component.exports